import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider, Input, Select, Space } from "antd";
import React, { useRef, useState } from "react";
import { degreeList } from "../../util/helper";
import { useTranslation } from "react-i18next";

const DegreeSelect = ({ lang = "en", value, onChange = () => {}, disabled = false }) => {
  const [newDegreeList, setNewDegreeList] = useState(degreeList);
  const [tmpDegree, setTmpDegree] = useState("");
  const { t } = useTranslation();

  const inputRef = useRef(null);
  const onTmpDegreeChange = (event) => {
    setTmpDegree(event.target.value);
  };
  const addItem = (e) => {
    e.preventDefault();
    if (tmpDegree.trim() !== "") {
      newDegreeList['vi'].push({"key": tmpDegree, "name": tmpDegree})
      newDegreeList['en'].push({"key": tmpDegree, "name": tmpDegree})
      setNewDegreeList(newDegreeList);
      setTmpDegree("");
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  };

  return (
    <Select
      value={value}
      onChange={onChange}
      className="custom-select"
      allowClear={true}
      disabled={disabled}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider
            style={{
              margin: "8px 0",
            }}
          />
          <Space
            style={{
              padding: "0 8px 4px",
            }}
          >
            <Input
              placeholder={t("str_input_degree")}
              ref={inputRef}
              value={tmpDegree}
              onChange={onTmpDegreeChange}
            />
            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
            {t("str_add_degree")}
            </Button>
          </Space>
        </>
      )}
      
      options={newDegreeList[lang || "vi"].map((item) => ({
        label: item.name,
        value: item.key,
      }))}
    />
  );
};

export default DegreeSelect;
